export const refreshTimeInterval = 60000;
export const statusActiveBackground = '#3F1223';



// WEBPACK FOOTER //
// ./src/constants/status.js